$(document).ready(function () {
    resize = function () {
        w = $(window).width();
        if (w < 768) {
            $('.teamgrid .col-1').insertAfter('.teamgrid .col-2');
        } else {
            $('.teamgrid .col-2').insertAfter('.teamgrid .col-1');
        }
    }

    resize();
    window.onresize = resize;
    $('#hamburger').click(function (e) {
        e.preventDefault();
        $('.hidebox').slideToggle();
    });

    $('#main-menu').smartmenus({
        subMenusSubOffsetX: 100,
        subMenusSubOffsetY: -5,
        subIndicatorsText: '<i class="fa fa-sort-desc"></i>',
    });
    $('.webticker').webTicker({
        startEmpty: false,
        speed: 80
    });
    var offset = 220;
    var duration = 500;

    $(window).scroll(function () {
        if (jQuery(this).scrollTop() > offset) {
            jQuery('.back-to-top').fadeIn(duration);
        } else {
            jQuery('.back-to-top').fadeOut(duration);
        }
    });


    $('.back-to-top').click(function (event) {

        event.preventDefault();
        jQuery('html, body').animate({
            scrollTop: 0
        }, duration);
        return false;
    })

});